import React from "react";

// Playful wavy edge. Drop it as the last child of a `position: relative` section and
// pass the background color of the section that comes next. Use `up` to sit above the
// parent's top edge instead (e.g. the footer rising into the page above it).
export default function Wave({ color, up = false }) {
  return (
    <svg
      className={`wave ${up ? "wave-up" : ""}`}
      viewBox="0 0 1440 90"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill={color}
        d="M0 45c120 40 240 40 360 0s240-40 360 0 240 40 360 0 240-40 360 0v45H0z"
      />
    </svg>
  );
}
